<template>
  <div>
    <div class="content-header">
      <div class="left">
        <span class="title">角色管理</span>
      </div>
      <div class="right">
        <Button type="primary" @click="saveModal(false)">新增角色</Button>
      </div>
    </div>
    <Table :columns="columns" :data="data" :loading="tableLoading" />

    <Modal
      v-model="modal.status"
      :title="modal.data.id ? '编辑角色' : '新增角色'"
      @on-ok="save"
      @on-cancel="modal.status = false"
      width="800"
    >
      <Form
        :model="modal.data"
        :label-width="80"
        :rules="modal.rule"
        ref="formValidate"
      >
        <FormItem label="角色名称" prop="name">
          <Input v-model="modal.data.name" placeholder="请输入角色名称"></Input>
        </FormItem>
        <FormItem label="权限配置" prop="params">
          <CheckboxGroup v-model="modal.data.params">
            <div
              v-for="(item, index) in modal.menu"
              :key="index"
              class="groupBox"
            >
              <p class="title">{{ item.title }}</p>
              <Checkbox
                v-for="(val, i) in item.children"
                :value="val.name"
                :label="val.name"
                :key="i"
                >{{ val.title }}</Checkbox
              >
            </div>
          </CheckboxGroup>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="modal.status = false">取消</Button>
        <Button type="primary" @click="save">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import route from "../../../router/routers";

export default {
  data() {
    return {
      modal: {
        status: false,
        data: {
          id: 0,
          name: "",
          params: [],
        },
        role: [
          {
            title: "设备列表",
            name: "machine",
          },
        ],
        rule: {
          name: [
            {
              required: true,
              message: "请输入角色名称",
              trigger: "blur",
            },
          ],
        },
        menu: [],
        values: [],
      },
      columns: [
        { title: "角色名称", key: "name" },
        {
          title: "操作",
          width: 240,
          key: "operator",
          render: (h, data) => {
            return [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  on: {
                    click: () => {
                      this.saveModal(data.row);
                    },
                  },
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small",
                  },
                  style: {
                    marginLeft: "10px",
                  },
                  on: {
                    click: () => {
                      this.SaveRole({
                        id: data.row.id,
                        is_del: 1,
                        name: data.row.name,
                      }).then((res) => {
                        this.$Message[res.status ? "success" : "error"](
                          res.status ? "删除成功" : "删除失败"
                        );
                        this.getData();
                      });
                    },
                  },
                },
                "删除"
              ),
            ];
          },
        },
      ],
      tableLoading: false,
      data: [],
    };
  },
  mounted() {
    this.initRoute();
    this.getData();
  },
  methods: {
    ...mapActions(["SaveRole", "GetRole"]),
    saveModal(data) {
      this.modal.status = true;
      if (data) {
        this.modal.data = {
          id: data.id,
          name: data.name,
          params: data.params,
        };
      } else {
        this.modal.data = {
          id: 0,
          name: "",
          params: this.modal.values,
        };
      }
    },
    save() {
      const data = {
        name: this.modal.data.name,
        params: this.modal.data.params.join(","),
      };
      if (this.modal.data.id) data.id = this.modal.data.id;
      this.SaveRole(data).then((res) => {
        this.$Message[res.status ? "success" : "error"](res.msg);
        if (res.status) {
          this.modal.status = false;
          this.getData();
        }
      });
    },
    initRoute() {
      let data = [];
      route.map((item) => {
        if (
          !item.meta.hideInMenu &&
          !item.meta.hide &&
          ((item.meta.access &&
            item.meta.access.length &&
            item.meta.access.indexOf(this.agent.tp.toString()) >= 0) ||
            !item.meta.access ||
            !item.meta.access.length)
        ) {
          let element = {
            title: item.meta.title || "",
            all: false,
            children: [],
          };
          if (item.children) {
            item.children.map((val) => {
              if (
                val.meta &&
                !val.meta.hideInMenu &&
                !val.meta.hide &&
                ((val.meta.access &&
                  val.meta.access.length &&
                  val.meta.access.indexOf(this.agent.tp.toString()) >= 0) ||
                  !val.meta.access ||
                  !val.meta.access.length)
              ) {
                element.children.push({
                  title: val.meta.title,
                  name: val.name,
                });
                this.modal.data.params.push(val.name);
                this.modal.values.push(val.name);
              }
            });
          }
          if (element.children.length) data.push(element);
        }
      });
      this.modal.menu = data;
    },
    getData() {
      this.tableLoading = true;
      this.GetRole({ l: 1000, p: 0 }).then((res) => {
        this.tableLoading = false;
        res.data.map((item) => {
          item.params = item.params.split(",");
        });
        this.data = res.data;
      });
    },
  },
  computed: mapGetters({ agent: "agent" }),
  watch: {},
};
</script>
<style lang='less'>
@import "./index.less";
</style>
